import styled from '@emotion/styled';
import { Chip, colors } from '@innovationdepartment/proxima-ui';

/* Selected chips are filled noticeably darker than the light hover
   state of unselected chips, so selection reads at a glance */
const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  .MuiChip-filled {
    background-color: ${colors.neutral60};
    color: ${colors.white};
  }

  .MuiChip-filled:hover {
    background-color: ${colors.neutral50};
  }
`;

type ChipToggleGroupProps = {
  options: Array<{ value: string; display: string }>;
  selected: string[];
  disabledValues?: string[];
  onToggle: (value: string) => void;
};

const ChipToggleGroup = ({
  options,
  selected,
  disabledValues = [],
  onToggle
}: ChipToggleGroupProps) => (
  <ChipRow>
    {options.map(option => {
      const isSelected = selected.includes(option.value);
      return (
        <Chip
          key={option.value}
          label={option.display}
          clickable
          variant={isSelected ? 'filled' : 'outlined'}
          disabled={disabledValues.includes(option.value)}
          onClick={() => onToggle(option.value)}
        />
      );
    })}
  </ChipRow>
);

export default ChipToggleGroup;
